import {
  useWSModal,
  WSActions,
  WSDivider,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";

import { WSQueries } from "../../../../../query/WSQuery";
import { openInNewTab } from "../../../../../shared/utils/openInNewTab";
import { queriesBackgroundChecks } from "../../../../../v3/query/queriesBackgroundChecks";

interface BackgroundChecksStartModalProps {
  onClose: () => void;
  backgroundCheckId: string;
}

// v1 showed the settings' instructions here; background-check settings have
// no v3 twin, and the v3 check carries no instructions — the candidate gets
// them at the vendor's hosted application instead
const BackgroundChecksStartModal: React.FC<BackgroundChecksStartModalProps> = ({
  onClose,
  backgroundCheckId
}) => {
  const backgroundCheckQuery =
    queriesBackgroundChecks.getBackgroundCheck.useQuery({ backgroundCheckId });

  return (
    <WSList gap="L">
      <WSEmptyState
        description="Click continue to open the background check portal in a new window. When you’ve finished with your background check requirement, return to Wingspan to complete your onboarding. You can access the portal and check the status from your Wingspan homepage."
        orientation="horizontal"
        size="M"
        title="Your payer has requested a background check to be completed."
        type="documents"
      />
      <WSQueries queries={{ backgroundCheckQuery }}>
        {({ backgroundCheckQueryData }) => {
          return (
            <>
              <WSDivider />
              <WSActions
                alignment="fill"
                buttons={[
                  {
                    label: "Continue",
                    kind: "Primary",
                    name: "submit",
                    onClick: async () => {
                      openInNewTab(backgroundCheckQueryData.applicationUrl!);
                      onClose();
                    }
                  }
                ]}
              />
            </>
          );
        }}
      </WSQueries>
    </WSList>
  );
};

export function useBackgroundChecksStartModal() {
  return useWSModal(BackgroundChecksStartModal, {
    title: "Background check requirement",
    size: "M"
  });
}
